import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { SidebarNavItem } from '@sendible/design-system';
import { SecondarySidebarStyled } from './index.styles';
import { defaultGetMediaLibrariesResponse, mediaLibraryIdParam } from '../../constants';
import { useMediaLibraryContext } from '../../context';
import { useGetMediaLibraries } from '../../../../models/mediaLibraries';
import useMediaLibraryOptions from '../../utils/useMediaLibraryOptions';

export const Sidebar = () => {
  const { data = defaultGetMediaLibrariesResponse, isLoading } = useGetMediaLibraries();
  const { getMediaLibraryOptions } = useMediaLibraryOptions();
  const { t } = useTranslation('media_library');

  const { activeMediaLibrary, setIsCreationModalOpen, setActiveMediaLibrary, sidebarIsVisible, setSidebarIsVisible, onNavigate } =
    useMediaLibraryContext();
  const [searchParams] = useSearchParams();
  const { mediaLibraries } = data;

  const ctaButtonLabel = t('sibebar_new_library_button');
  const title = t('sidebar_title');
  const ariaMediaLibraryListLabel = t('aria_media_library_list');
  const ariaMediaLabel = t('aria_media_library');
  const ariaAddNewLabel = t('aria_add_new');

  const secondarySidebarContent = mediaLibraries.map((mediaLibrary: MediaLibraryType) => (
    <SidebarNavItem
      click={() => onNavigate(mediaLibrary)}
      data-testid={mediaLibrary.name}
      dropdownButtonClick={(action) => getMediaLibraryOptions(mediaLibrary).actionHandlers[action]()}
      dropDownOptions={getMediaLibraryOptions(mediaLibrary).optionsList}
      id={mediaLibrary.id}
      isActive={activeMediaLibrary?.id === mediaLibrary.id}
      key={mediaLibrary.id}
      label={mediaLibrary.name}
      ariaItemLabel={`${ariaMediaLabel}: ${mediaLibrary.name}`}
    />
  ));

  useEffect(() => {
    const findMediaLibrary = (id?: string | null) => mediaLibraries.find((mediaLibrary: MediaLibraryType) => mediaLibrary.id == id);

    if (mediaLibraries.length > 0) {
      const newMediaLibrary = findMediaLibrary(activeMediaLibrary?.id || searchParams.get(mediaLibraryIdParam));

      setActiveMediaLibrary(newMediaLibrary || mediaLibraries[0]);
    }
  }, [mediaLibraries]);

  return (
    <SecondarySidebarStyled
      ctaButtonIcon="plus"
      ctaButtonLabel={ctaButtonLabel}
      cta={() => setIsCreationModalOpen(true)}
      isVisible={sidebarIsVisible}
      isLoading={isLoading}
      title={title}
      close={() => setSidebarIsVisible(false)}
      ariaLabel={ariaMediaLibraryListLabel}
      ariaAddNewLabel={ariaAddNewLabel}
    >
      {secondarySidebarContent}
    </SecondarySidebarStyled>
  );
};
